var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.copyright)}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.beian)}})])}
var staticRenderFns = []

export { render, staticRenderFns }